import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { AppEnvironment } from '@web/csl-lib-models';

@Component({
  selector: 'csl-non-prod-banner',
  imports: [],
  templateUrl: './non-prod-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './non-prod-banner.component.css',
})
export class NonProdBannerComponent {
  environment = input<AppEnvironment>();
}
